// remove all params from url data-js-removeparam
S.removeparam = {
    init()
    {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};
